import { PLACE_CATEGORY_PRODUCTS } from './categories'
import { type IProductGroup } from '../model'
import { parsePrice } from './parsePrice'

export const ENGINE_OIL_SECTION = 'oil_set'
export const TIRE_SECTION = 'tire'
export const CAR_WASH_SECTION = 'car_wash'

export const SECTION_NAME_BY_CODE: Record<string, string> = Object.fromEntries(
  PLACE_CATEGORY_PRODUCTS.map(category => [category.section, category.name])
)

export const SECTION_ORDER_INDEX: Record<string, number> = Object.fromEntries(
  PLACE_CATEGORY_PRODUCTS.map((category, index) => [category.section, index])
)

// 한글 받침 유무에 따라 주격 조사 은/는 반환. 비한글 어미는 '는' fallback.
export const getSubjectParticle = (name: string | null | undefined): string => {
  if (!name) return '는'
  const last = name[name.length - 1]
  if (!last) return '는'
  const code = last.charCodeAt(0)
  if (code < 0xac00 || code > 0xd7a3) return '는'
  return (code - 0xac00) % 28 === 0 ? '는' : '은'
}

export interface IProductForPrice {
  name: string
  price: number
}

// section → PLACE_CATEGORY_PRODUCTS의 한글 표기로 고정 매핑 (API title 무시)
export const findCheapestProduct = (
  productGroups: IProductGroup[]
): IProductForPrice | null => {
  let cheapest: IProductForPrice | null = null
  for (const group of productGroups) {
    const product = group.lowestPriceTargetProduct
    if (!product?.salePrice) continue
    const price = parsePrice(product.salePrice)
    if (price <= 0) continue
    const name = SECTION_NAME_BY_CODE[group.section ?? '']
    if (!name) continue
    if (!cheapest || price < cheapest.price) {
      cheapest = { name, price }
    }
  }
  return cheapest
}

// 디테일링(car_wash) group의 targetProducts 중 최저 salePrice product의 productName 사용
export const findCarWashCheapestProduct = (
  productGroups: IProductGroup[]
): IProductForPrice | null => {
  let cheapest: IProductForPrice | null = null
  for (const group of productGroups) {
    if (group.section !== CAR_WASH_SECTION) continue
    for (const product of group.targetProducts ?? []) {
      const price = parsePrice(product.salePrice)
      if (price <= 0) continue
      const name = product.productName?.trim()
      if (!name) continue
      if (!cheapest || price < cheapest.price) {
        cheapest = { name, price }
      }
    }
  }
  return cheapest
}
